import { useAuth } from '@/domains/auth/authProvider';

import { type PerspectiveIcon, iconForPerspective } from './perspectiveIcon';

/**
 * Brand icon for the logged-in user's active perspective.
 * Falls back to the default shield when there is no user, no active
 * perspective, or an unknown perspective name.
 */
export function usePerspectiveIcon(): PerspectiveIcon {
  const { user } = useAuth();
  return iconForPerspective(user?.activePerspective?.name);
}
